import { render } from "./RoofingPage.vue?vue&type=template&id=5d69209c&scoped=true"
import script from "./RoofingPage.vue?vue&type=script&lang=js"
export * from "./RoofingPage.vue?vue&type=script&lang=js"

import "./RoofingPage.vue?vue&type=style&index=0&id=5d69209c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d69209c"]])

export default __exports__